const PROD_APP_URL = process.env.REACT_APP_PROD_APP_URL || "";
const API_URL = process.env.REACT_APP_API_URL || "";
const DEV_API_URL = process.env.REACT_APP_DEV_API_URL || "";
const PROD_API_URL = process.env.REACT_APP_PROD_API_URL || "";

const apiBaseUrl =
  window.location.hostname === "localhost"
    ? API_URL
    : window.location.hostname === new URL(PROD_APP_URL).hostname
    ? PROD_API_URL
    : DEV_API_URL;

export const uploadSpecialReleaseForm = async (
  file: File,
  orderFormID: number
) => {
  if (!apiBaseUrl) throw new Error("API URL is not defined");

  const formData = new FormData();
  formData.append("file", file);

  const response = await fetch(
    `${apiBaseUrl}/api/SpecialReleaseForms/UploadSpecialReleaseForm?orderFormID=${orderFormID}`,
    {
      method: "POST",
      body: formData,
    }
  );

  if (!response.ok) {
    throw new Error("Failed to upload special release form.");
  }

  return response.json();
};

export const getSpecialReleaseFormAdmin = async (type: string) => {
  if (!apiBaseUrl) throw new Error("API URL is not defined");

  const response = await fetch(
    `${apiBaseUrl}/api/SpecialReleaseForms/GetSpecialReleaseFormAdmin?type=${type}`
  );

  if (!response.ok) {
    throw new Error("Failed to get special release form.");
  }

  const data = await response.json();
  if (data.success) {
    return data.url;
  } else {
    throw new Error(data.message || "No form found.");
  }
};
